import { render, staticRenderFns } from "./addPromote.vue?vue&type=template&id=298507b4&scoped=true&"
import script from "./addPromote.vue?vue&type=script&lang=js&"
export * from "./addPromote.vue?vue&type=script&lang=js&"
import style0 from "./addPromote.vue?vue&type=style&index=0&id=298507b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298507b4",
  null
  
)

export default component.exports